import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    titleGeneral: {
        id: 'cards.top_up.modal.title_general',
        defaultMessage: 'Top up your card',
    },
    titleConfirm: {
        id: 'cards.top_up.modal.title_confirm',
        defaultMessage: 'Confirmation',
    },
})
